/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.userProfileUpdate.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@ExperimentalJsExport
@JsExport
@Serializable
data class UpdateUserProfileRequest(
    /** The users&#39; updated email address */
    @SerialName("email")
    val email: String?,

    /** The users&#39; updated phone number */
    @SerialName("phone")
    val phone: String?,

    /** The users&#39; updated country code */
    @SerialName("country_code")
    val countryCode: String?,

    /** The users&#39; updated first name */
    @SerialName("first_name")
    val firstName: String?,

    /** The users&#39; updated last name */
    @SerialName("last_name")
    val lastName: String?,

    /** The users&#39; updated date of birth. The date must be formated as \&quot;1990-11-25\&quot;  */
    @SerialName("birth_date")
    val birthDate: String?,

    /** The users&#39; update language. Must follow ISO 639-1 format (eg. en, fr, es)  */
    @SerialName("language")
    val language: String?,

    /** The users&#39; updated gender. Current accepted values are \&quot;male\&quot; and \&quot;female\&quot;  */
    @SerialName("gender")
    val gender: String?,

    /** A url to the users&#39; updated profile photo. If you&#39;d like to upload the photo to Kangaroo&#39;s server beforehand, use the userProfilePhotoUpload api - it will return a url that can be used in this api.  */
    @SerialName("profile_photo")
    val profilePhoto: String?,

    @SerialName("address")
    val address: AddressModel?
)
